var $067dbd0c037ad155$exports = {};
$067dbd0c037ad155$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};


export {$067dbd0c037ad155$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
